import React, { useState, useRef, useMemo } from 'react';
import styled from 'styled-components';
import useOnClickOutside from '../../hooks/useOnClickOutside';
import { FlexMiddle } from '../Flex';
import { responsiveShow, responsiveHide } from '../../style';
import BaseModal from '../Modal';
import { ReactComponent as Arrow } from '../../assets/arrow-right-small.svg';
import { linkTab } from './LinkTab';

const Wrapper = styled(FlexMiddle)`
  position: relative;
`;

const Modal = styled(BaseModal)`
  .content {
    align-items: center;
  }
`;

const SelectedValue = styled(FlexMiddle)`
  cursor: pointer;
  ${responsiveHide.tablet};

  > svg {
    margin-left: -13px;
    transform: rotate(${({ isOpen }) => (isOpen ? -90 : 90)}deg);
  }

  > a,
  > div {
    display: none;
    pointer-events: none;
    margin-right: 30px;
    &.active {
      display: flex;
    }
  }
`;

const Options = styled(FlexMiddle)`
  ${responsiveShow.tablet};
`;

const Option = styled(FlexMiddle)`
  > a,
  > div {
    ${linkTab};
    margin-right: 0;
    background: ${({ theme }) => theme.colors.white}!important;
    color: ${({ theme }) => theme.colors.black}!important;
  }
`;

const LinksContainer = ({ children, className, modalContainerClassName, usePortal = true }) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef();
  useOnClickOutside(ref, () => setIsOpen(false), true, 'modal');

  const childrenWithCloseClick = useMemo(
    () => React.Children.map(children, (child) => <Option onClick={() => setIsOpen(false)}>{child}</Option>),
    [children]
  );

  return (
    <Wrapper ref={ref} className={className}>
      <SelectedValue isOpen={isOpen} onClick={() => setIsOpen(true)}>
        {children}
        <Arrow />
      </SelectedValue>
      <Options>{children}</Options>

      {isOpen && (
        <Modal
          size="xs"
          className={modalContainerClassName}
          showConfirmButton={false}
          onClose={() => setIsOpen(false)}
          usePortal={usePortal}>
          {childrenWithCloseClick}
        </Modal>
      )}
    </Wrapper>
  );
};

export default LinksContainer;
